import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { CountertopUniversityProfile } from '../types/CountertopUniversityProfile';

export const useGetCountertopProfiles = (companyID?: number) => {
    const { data, isLoading, refetch, isRefetching } = useQuery({
        queryKey: ['get-profiles', companyID],
        queryFn: async () => await apiClient.get(`countertop-university/get-profiles`) as CountertopUniversityProfile[]
    });

    return {
        data: data || [],
        isLoading,
        refetch: refetch,
        isRefetching: isRefetching
    };
};
